import React from "react";

export function ProgressiveBlur({
  direction = "left",
  blurIntensity = 1,
  className = "",
}) {
  const gradientDirection = direction === "left" ? "to right" : "to left";

  return (
    <div
      className={className}
      style={{
        background: `linear-gradient(${gradientDirection}, white, transparent)`,
        backdropFilter: `blur(${blurIntensity}px)`,
        WebkitBackdropFilter: `blur(${blurIntensity}px)`,
      }}
    />
  );
}